import type { EffortLevel } from '../hooks/useModels';

interface Props {
  open: boolean;
  effort: EffortLevel;
  onConfirm: () => void;
  onCancel: () => void;
  /** Optional shortcut to drop down to `high` and resend without confirmation next time */
  onDropToHigh?: () => void;
}

const COPY: Record<'xhigh' | 'max', { title: string; cost: string; tone: string }> = {
  xhigh: {
    title: 'Send at X-High effort?',
    cost: '~6× normal Opus turn',
    tone: 'Slower and more expensive than your usual session.',
  },
  max: {
    title: 'Send at MAX effort?',
    cost: '~8–10× normal Opus turn',
    tone: 'Maximum reasoning depth — the most expensive single turn.',
  },
};

export function HighCostEffortModal({ open, effort, onConfirm, onCancel, onDropToHigh }: Props) {
  if (!open) return null;
  const isHighCost = effort === 'xhigh' || effort === 'max';
  if (!isHighCost) return null;
  const copy = COPY[effort as 'xhigh' | 'max'];
  return (
    <div class="hcem-backdrop" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="hcem-title">
      <div class="hcem-card" onClick={(e) => e.stopPropagation()}>
        <div class="hcem-icon" aria-hidden="true">{effort === 'max' ? '🔥' : '⚡'}</div>
        <h3 id="hcem-title" class="hcem-title">{copy.title}</h3>
        <p class="hcem-cost"><strong>{copy.cost}</strong></p>
        <p class="hcem-tone">{copy.tone}</p>
        <p class="hcem-help">This confirmation appears every time so you stay in control of your spend.</p>
        <div class="hcem-actions">
          <button class="hcem-btn hcem-btn-cancel" onClick={onCancel} type="button">Cancel</button>
          {onDropToHigh && (
            <button class="hcem-btn hcem-btn-secondary" onClick={onDropToHigh} type="button">
              Drop to High
            </button>
          )}
          <button class="hcem-btn hcem-btn-primary" onClick={onConfirm} type="button" autofocus>
            Send anyway
          </button>
        </div>
      </div>
    </div>
  );
}
